/**
 * Form submission utility for creating and submitting forms programmatically
 */

/**
 * Creates a form element with POST method and submits it, causing a physical redirect
 *
 * @param actionURL - The URL to which the form will be submitted
 * @param formData - Object containing key-value pairs for form fields
 * @param target - Optional target for form submission (default: '_self')
 *
 * @example <caption>Example of formSubmit module usage</caption>
 * import { submitForm } from 'widgets/toolbox/formSubmit';
 * submitForm('https://example.com/submit', { key1: 'value1', key2: 'value2' });
 */
export function submitForm(actionURL: string, formData: Record<string, string>, target: string = '_self'): void {
    const form = document.createElement('form');

    form.method = 'POST';
    form.action = actionURL;
    form.target = target;
    form.hidden = true;

    // Add form data as hidden input fields
    Object.keys(formData).forEach(key => {
        const input = document.createElement('input');

        input.type = 'hidden';
        input.name = key;
        input.value = formData[key] || '';
        form.appendChild(input);
    });

    // Append form to body, submit immediately, then remove
    document.body.appendChild(form);

    // Submit form immediately
    form.submit();

    // Remove form from DOM immediately after submission
    // The redirect will happen regardless of form removal
    form.remove();
}
